import type { AuthSession } from "../auth/models/session.model";
import { saveSession } from "../auth/auth.storage";
import { clearSsoRelayGuards } from "../auth/sso-relay-guard";
import { seedSuiteSessionInBackground } from "./suite-session-seed";

const HANDOFF_MAX_AGE_MS = 5 * 60_000;

interface HandoffPayload {
  session: AuthSession;
  targetPath?: string;
  issuedAt: number;
}

export function parseHandoffPayload(hash: string): HandoffPayload | null {
  const raw = hash.replace(/^#/, "");
  const match = raw.match(/(?:^|&)payload=([^&]+)/);
  if (!match) return null;

  try {
    const b64 = decodeURIComponent(match[1].replace(/\+/g, "%2B"));
    const json = decodeURIComponent(atob(b64));
    const payload = JSON.parse(json) as HandoffPayload;
    if (!payload.session?.tokens?.accessToken) return null;
    if (Date.now() - payload.issuedAt > HANDOFF_MAX_AGE_MS) return null;
    return payload;
  } catch {
    return null;
  }
}

export interface ApplyHandoffOptions {
  /** Après handoff module, propage la session vers Suite (iframe silencieuse). */
  seedSuiteUrl?: string;
}

export function applyHandoffFromHash(
  hash: string,
  options?: ApplyHandoffOptions,
): string | null {
  const payload = parseHandoffPayload(hash);
  if (!payload) return null;

  saveSession(payload.session);
  clearSsoRelayGuards();
  if (options?.seedSuiteUrl) {
    seedSuiteSessionInBackground(options.seedSuiteUrl, payload.session);
  }
  return payload.targetPath ?? "/";
}
